import { service } from "../utils/request";

// ic卡
export function bindingIc(data) {
  return service({
    url: "user/agent.UsersPhysicalCard/add",
    method: "post",
    data: data
  });
}
export function detailIc(data) {
  return service({
    url: "user/agent.UsersPhysicalCard/detail",
    method: "post",
    data: data
  });
}
// 卡号搜索会员
export function searchCardIc(data) {
  return service({
    url: "user/agent.User_level_card/search_card",
    method: "post",
    data: data
  });
}
export function judgePayPass(data) {
  return service({
    url: "user/agent.index/judgePayPass",
    method: "post",
    data: data
  });
}
export function setPayPass(data) {
  return service({
    url: "user/agent.index/setPayPass",
    method: "post",
    data: data
  });
}
// 用户验证码
export function iCSendSms(data) {
  return service({
    url: "user/agent.index/send_sms",
    method: "post",
    data: data
  });
}
// 验证密码
export function verifyPayPass(data) {
  return service({
    url: "user/agent.index/verifyPayPass",
    method: "post",
    data: data
  });
}
// 用户验证码
export function CardAvailable(url, data) {
  return service({
    url: url,
    method: "post",
    data: data
  });
}
// 获取所有油卡
export function getOilCards(data) {
  return service({
    url: "/offlinestore/agent.Offline_Type_Card/available",
    method: "post",
    data: data
  });
}
// 获取充值详情
export function getOilCardsDetail(data) {
  return service({
    url: "/user/agent.ConfigRecharge/detail",
    method: "post",
    data: data
  });
}
// 充值
export function rechargePay(data) {
  return service({
    url: "/user/agent.account/recharge",
    method: "post",
    data: data
  });
}
// 支付结果
export function searchOrder(data) {
  return service({
    url: "/user/agent.account/search_order",
    method: "post",
    data: data
  });
}
//充值详情
export function rechargeDetail(data) {
  return service({
    url: "offlinestore/agent.recharge/detail",
    method: "post",
    data: data
  });
}
//扫码支付
export function scan_pay(data) {
  return service({
    url: "creditshop/agent.creditshop_goods_order/submit_scan_shoporder_money",
    method: "post",
    data: data
  });
}
